import { BsArrowUpCircleFill } from "react-icons/bs";

const TopButton = () => {
    return ( 
        <a href="#" id="scrollTopBtn">
          <BsArrowUpCircleFill />
        </a>
     );
}
 
export default TopButton;